"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventrDate = void 0;
const luxon_1 = require("luxon");
const underscore_1 = require("underscore");
const eventr_interface_1 = require("../interfaces/eventr.interface");
const itinInfo_context_1 = require("../state/itinInfo.context");
const dateTypeRegEx_1 = require("./dateTypeRegEx");
const generateDateString_1 = require("./generateDateString");
const getDateCommon_1 = require("./getDateCommon");
const luxonEventrDateConvert_1 = require("./luxonEventrDateConvert");
const other_1 = require("./other");
/// MAT has refactored this to not use JSDate and insteaed use Luxon date...
/**
 * Accept string or unix number(ms)
 */
class EventrDate {
    _luxonDateTime;
    _override;
    _timezoneEnum;
    constructor(date) {
        let dateToUse = date;
        /// Is undifined or emptystr or null (should problally errror to console if null or empty)
        if ((0, underscore_1.isUndefined)(dateToUse) || dateToUse === '' || (0, underscore_1.isNull)(dateToUse)) {
            /// Use now / debug date if exists instead
            const debugDateTime = (0, getDateCommon_1.getDebugDate)();
            if (debugDateTime) {
                dateToUse = debugDateTime;
            }
            else {
                /// Time now with timezone info from luxon
                this._luxonDateTime = luxon_1.DateTime.now();
                this._override = true; /// set to users local. needs to be cleared if desired
                this._timezoneEnum = (0, eventr_interface_1.getTimezoneNumber)(this._luxonDateTime.zoneName);
                return;
            }
        }
        /// Is Number
        if (typeof dateToUse === 'number') {
            this._luxonDateTime = luxon_1.DateTime.fromMillis((0, other_1.switchUnixToMs)(dateToUse));
            this._override = false;
            this._timezoneEnum = undefined;
            return;
        }
        /// Is String to parse
        if (typeof dateToUse === 'string') {
            /// New New New Eventr date formate. inc, O/N and CC Enum
            if ((0, dateTypeRegEx_1.isEventrDate)(dateToUse)) {
                const luxonDate = (0, luxonEventrDateConvert_1.getLuxonFromEventrDate)(dateToUse);
                if (luxonDate) {
                    this._luxonDateTime = luxonDate;
                    this._override =
                        dateToUse.includes('O') &&
                            (0, eventr_interface_1.getTimezoneNumber)(luxonDate.zoneName)
                            ? true
                            : false;
                    this._timezoneEnum = (0, eventr_interface_1.getTimezoneNumber)(luxonDate.zoneName);
                }
                else {
                    /// error
                }
                return;
            }
            /// Legacy Eventr date formate. inc, O/N
            if ((0, dateTypeRegEx_1.isLegacyEventrDate)(dateToUse)) {
                const luxonDate = (0, luxonEventrDateConvert_1.getLuxonFromLegacyEventrDate)(dateToUse);
                if (luxonDate) {
                    this._luxonDateTime = luxonDate;
                    this._override = dateToUse.includes('O');
                    this._timezoneEnum = undefined;
                }
                return;
            }
            /// Old iso standered
            if ((0, dateTypeRegEx_1.isVeryLegacyEventrDate)(dateToUse)) {
                /// Luxon should parse as is iso format
                const luxonDate = luxon_1.DateTime.fromISO(dateToUse);
                if (luxonDate.isValid) {
                    this._luxonDateTime = luxonDate;
                    this._override = false;
                    this._timezoneEnum = undefined;
                }
                else {
                    /// error
                }
                return;
            }
            /// default unzoned datetime dashes
            if ((0, dateTypeRegEx_1.isDefaultUnzonedDatetimeDash)(dateToUse)) {
                const luxonDate = luxon_1.DateTime.fromFormat(dateToUse, 'yyyy-MM-dd hh:mm');
                if (luxonDate.isValid) {
                    this._luxonDateTime = luxonDate;
                    this._override = false;
                    this._timezoneEnum = undefined;
                }
                else {
                    /// error
                }
                return;
            }
            /// default unzoned datetime slashes
            if ((0, dateTypeRegEx_1.isDefaultUnzonedDatetimeSlash)(dateToUse)) {
                const luxonDate = luxon_1.DateTime.fromFormat(dateToUse, 'yyyy/MM/dd hh:mm');
                if (luxonDate.isValid) {
                    this._luxonDateTime = luxonDate;
                    this._override = false;
                    this._timezoneEnum = undefined;
                }
                else {
                    /// error
                }
                return;
            }
            /// short date standered
            if ((0, dateTypeRegEx_1.isShortDate)(dateToUse)) {
                /// Luxon should parse as is iso format
                const luxonDate = luxon_1.DateTime.fromISO(dateToUse);
                if (luxonDate.isValid) {
                    this._luxonDateTime = luxonDate;
                    this._override = false;
                    this._timezoneEnum = undefined;
                }
                else {
                    /// error
                }
                return;
            }
            /// time standered???
            if ((0, dateTypeRegEx_1.isTimeString)(dateToUse)) {
                const luxonDate = (0, luxonEventrDateConvert_1.getLuxonFromTimeString)(dateToUse);
                if (luxonDate) {
                    this._luxonDateTime = luxonDate;
                    this._override = false;
                    this._timezoneEnum = undefined;
                }
                else {
                    /// error
                }
                return;
            }
            if (luxon_1.DateTime.fromISO(dateToUse).isValid) {
                this._luxonDateTime = luxon_1.DateTime.fromISO(dateToUse).setZone('utc');
                this._override = false;
                this._timezoneEnum = undefined;
                return;
            }
        }
        /// Else throw error as not valid string
        throw new Error('Invalid DateTime String. Did not parse correctly. ' +
            dateToUse +
            ' --- ' +
            date);
    }
    /// SETTERS
    setFromObject(obj) {
        try {
            this._luxonDateTime = this._luxonDateTime.set(obj);
        }
        catch {
            /// invalid?
        }
        return this;
    }
    /**
     * set timezone from string.
     */
    setTimezone(timezone, keepSameTime) {
        const keepSameTimeUse = keepSameTime === false ? false : true;
        const enumValue = (0, eventr_interface_1.getTimezoneNumber)(timezone);
        if (!isNaN(enumValue)) {
            this._luxonDateTime = this._luxonDateTime.setZone(timezone, {
                keepLocalTime: keepSameTimeUse,
            });
            this._timezoneEnum = enumValue;
            this._override = true;
        }
        else {
            /// error
        }
        return this;
    }
    /**
     * set timezone from enum number.
     */
    setTimezoneEnum(tzEnum, keepSameTime) {
        const keepSameTimeUse = keepSameTime === false ? false : true;
        const nameValue = (0, eventr_interface_1.getTimezoneName)(tzEnum);
        if (nameValue) {
            this._luxonDateTime = this._luxonDateTime.setZone(nameValue, {
                keepLocalTime: keepSameTimeUse,
            });
            this._timezoneEnum = tzEnum;
            this._override = true;
        }
        else {
            /// error
        }
        return this;
    }
    /**
     * unset the tz. (N) and returns an eventr date for use. (is not a copy...)
     */
    clearTimezone() {
        this._luxonDateTime = this._luxonDateTime.setZone('utc', {
            keepLocalTime: true,
        });
        this._timezoneEnum = undefined;
        this._override = false;
        return this;
    }
    //// GETTERS
    /**
     * What is usally saved in the db, formate of eventrDate
     * does not use private getluxon() as that would change the time is not overwritten
     */
    get dateTimeString() {
        return (0, generateDateString_1.generateDateStringFromLuxon)(this._luxonDateTime, this._override);
    }
    /**
     * Is valid luxon datetime
     */
    get isValid() {
        return this.getTimezonedLuxon().isValid;
    }
    /**
     * Give luxon datetime to use. Is a clone.
     */
    get itinLocalLuxon() {
        const returnClone = this.getCloneEventrDate();
        return returnClone.getTimezonedLuxon();
    }
    /**
     * Give luxon datetime to use. Is a clone.
     */
    get userLocalLuxon() {
        const returnClone = this.getCloneEventrDate();
        return returnClone.getTimezonedLuxon(true);
    }
    /**
     * Give luxon datetime to use. Is a clone.
     */
    get utcLuxon() {
        const returnClone = this.getCloneEventrDate();
        return returnClone.getTimezonedLuxon().toUTC();
    }
    /**
     * To get timezone
     * can be undefined, idk why it thinks it cant be...
     */
    get timezoneNumber() {
        return this._timezoneEnum;
    }
    /**
     * To get override status
     */
    get isOverriden() {
        return this._override;
    }
    get getUnixMs() {
        return this.getTimezonedLuxon().toMillis();
    }
    /**
     * How many ms something is from now. mod(ms)
     */
    get getUnixMsToNow() {
        const dateTimeNow = new EventrDate();
        const msToNow = Math.abs(dateTimeNow.getUnixMs - this.getTimezonedLuxon().toMillis());
        return msToNow;
    }
    //// Functions
    /// DATETIME STRING
    /**
     * @returns For use for iso standered yyyy-mm-dd hh:mm
     */
    toItinLocalDateTimeString() {
        return this.getTimezonedLuxon().toFormat('yyyy-MM-dd HH:mm');
    }
    /**
     * @returns For use for iso standered yyyy-mm-dd hh:mm
     */
    toUTCDateTimeString() {
        return this.getTimezonedLuxon().toUTC().toFormat('yyyy-MM-dd HH:mm');
    }
    /**
     * @returns For use for iso standered yyyy-mm-dd hh:mm
     */
    toUserLocalDateTimeString() {
        return this.getTimezonedLuxon(true).toFormat('yyyy-MM-dd HH:mm');
    }
    /// DATE STRING
    /**
     * @returns For use for iso standered yyyy-mm-dd
     */
    toItinLocalDateString() {
        return this.getTimezonedLuxon().toFormat('yyyy-MM-dd');
    }
    /**
     * @returns For use for iso standered yyyy-mm-dd
     */
    toUTCDateString() {
        return this.getTimezonedLuxon().toUTC().toFormat('yyyy-MM-dd');
    }
    /**
     * @returns For use for iso standered yyyy-mm-dd
     */
    toUserLocalDateString() {
        return this.getTimezonedLuxon(true).toFormat('yyyy-MM-dd');
    }
    /// TIME STRING
    /**
     * @returns For use for iso standered hh:mm
     */
    toItinLocalTimeString() {
        return this.getTimezonedLuxon().toFormat('HH:mm');
    }
    /**
     * @returns For use for iso standered hh:mm
     */
    toUTCTimeString() {
        return this.getTimezonedLuxon().toUTC().toFormat('HH:mm');
    }
    /**
     * @returns For use for iso standered hh:mm
     */
    toUserLocalTimeString() {
        return this.getTimezonedLuxon(true).toFormat('HH:mm');
    }
    /// STYLED OTHER
    toItinLocalStyledShortDateString(languageLocal) {
        return this.getTimezonedLuxon()
            .setLocale(languageLocal)
            .toLocaleString(luxon_1.DateTime.DATE_SHORT);
    }
    toUserLocalStyledShortDateString(languageLocal) {
        return this.getTimezonedLuxon()
            .setLocale(languageLocal)
            .toLocaleString(luxon_1.DateTime.DATE_SHORT);
    }
    toItinLocalStyledLongDateString(languageLocal) {
        return this.getTimezonedLuxon()
            .setLocale(languageLocal)
            .toLocaleString(luxon_1.DateTime.DATE_HUGE);
    }
    toUserLocalStyledLongDateString(languageLocal) {
        return this.getTimezonedLuxon()
            .setLocale(languageLocal)
            .toLocaleString(luxon_1.DateTime.DATE_HUGE);
    }
    /**
     * @description Returns a date in the format Mon 1st Jan or Fri 17th Dec
     */
    toUserLocalLongDateAbr() {
        const luxonDateTime = this.getTimezonedLuxon(true);
        return luxonDateTime.toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
        });
    }
    /**
     * @description Returns a date in the format Mon 1st Jan or Fri 17th Dec
     */
    toItinLocalLongDateAbr() {
        const luxonDateTime = this.getTimezonedLuxon();
        return luxonDateTime.toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
        });
    }
    /**
     * @description Returns a date in the format Monday 1st Jan or Fri 17th Dec
     */
    toUserLocalLongDate() {
        const luxonDateTime = this.getTimezonedLuxon(true);
        return luxonDateTime.toLocaleString({
            weekday: 'long',
            month: 'long',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
        }, {});
    }
    /// Functions
    /**
     * Add to Luxon datetime
     */
    add(add) {
        this._luxonDateTime = this._luxonDateTime.plus(add);
        return this;
    }
    /**
     * Subtract to Luxon datetime
     */
    subtract(subtract) {
        this._luxonDateTime = this._luxonDateTime.minus(subtract);
        return this;
    }
    /**
     * Get luxon date for output (overly complicated due to dealing with legacy datetimes.)
     */
    getTimezonedLuxon(toUserLocal) {
        let cloneOfPrivateDateTime = this.getCloneLuxonDateTime();
        if (!this._override) {
            /// not overridden, use itin timezone. (should be showing local to the itin tz)
            const savedTimeZone = itinInfo_context_1.useItinInfo.getState().timezone;
            if (savedTimeZone) {
                cloneOfPrivateDateTime = cloneOfPrivateDateTime.setZone(savedTimeZone, {
                    keepLocalTime: true,
                });
            }
        }
        else if (this._override) {
            /// is overridden, leave the tz unless no tz is set.
            if (this._timezoneEnum === undefined) {
                /// is overridden but not set to a timezone... probs from lagacy dates
                /// dispaly in itin timezone?
                const savedTimeZone = itinInfo_context_1.useItinInfo.getState().timezone;
                if (savedTimeZone) {
                    cloneOfPrivateDateTime = cloneOfPrivateDateTime.setZone(savedTimeZone, {
                        keepLocalTime: true,
                    });
                }
                if (toUserLocal) {
                    return cloneOfPrivateDateTime.setZone('local', {
                        keepLocalTime: true,
                    });
                }
            }
        }
        if (toUserLocal) {
            return cloneOfPrivateDateTime.toLocal();
        }
        return cloneOfPrivateDateTime;
    }
    /**
     * Gets equilvent js date for convienence...
     */
    getJsDate() {
        return this.getTimezonedLuxon().toJSDate();
    }
    /**
     * To recieve a clone of the EventrDate. Not a reference, a deep clone.
     * Use this over "new EventrDate(oldEventrDate.dateTimeString)"
     */
    getCloneEventrDate() {
        const thisEventrDate = this;
        const cloneOfThis = new EventrDate();
        Object.assign(cloneOfThis, thisEventrDate);
        return cloneOfThis;
    }
    getCloneLuxonDateTime() {
        const thisDateTime = this._luxonDateTime;
        const cloneOfThis = luxon_1.DateTime.now();
        Object.assign(cloneOfThis, thisDateTime);
        return cloneOfThis;
    }
}
exports.EventrDate = EventrDate;
